var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7031 1.03223H2.29688C1.71094 1.03223 1.125 1.61816 1.125 2.2041V15.3879C1.125 15.9738 1.71094 16.5597 2.29688 16.5597H8.15625V17.7316C8.15625 18.5454 7.10063 18.9035 5.8125 18.9035V19.7822H15.1875V18.9032C13.8991 18.9032 12.8438 18.545 12.8438 17.7313V16.5594H18.7031C19.2891 16.5594 19.875 15.9735 19.875 15.3875V2.2041C19.875 1.61816 19.2891 1.03223 18.7031 1.03223ZM19.25 15.3879C19.25 15.6282 18.9431 15.9347 18.7031 15.9347H2.29688C2.05656 15.9347 1.75 15.6282 1.75 15.3879V14.216H19.25V15.3879Z",
    fill: "#69B9E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.681C10.6619 15.681 10.7932 15.5497 10.7932 15.3879C10.7932 15.226 10.6619 15.0947 10.5 15.0947C10.3381 15.0947 10.2069 15.226 10.2069 15.3879C10.2069 15.5497 10.3381 15.681 10.5 15.681Z",
    fill: "#69B9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ea5e83a7427c22b4115651410bee92e1.svg";
export { ForwardRef as ReactComponent };